export default theme => ({

  nested: {
    marginLeft: theme.spacing.unit * 2.25,
    borderLeft: '1px solid #aaaaaa'
  },

  '@media (min-width: 600px)': {

    nested: {
      marginLeft: theme.spacing.unit * 4.5,
    }

  }

});




// WEBPACK FOOTER //
// ./src/styles/components/TreeList.js